var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreamlineIconAwardTrophyStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.996 15.75v3m6.365 4.5a6.751 6.751 0 0 0-12.73 0ZM16.5.75h3.75a1.5 1.5 0 0 1 1.5 1.5V6a9.75 9.75 0 0 1-19.5 0V2.25a1.5 1.5 0 0 1 1.5-1.5H7.5",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12.53 2.573 1.249 2.458h2.127a.582.582 0 0 1 .419 1l-1.953 1.918 1.082 2.485a.589.589 0 0 1-.839.737L12 9.7l-2.615 1.471a.589.589 0 0 1-.839-.737l1.082-2.485-1.953-1.922a.582.582 0 0 1 .419-1h2.127l1.249-2.454a.594.594 0 0 1 1.06 0Z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconAwardTrophyStar);
export default __webpack_public_path__ + "static/media/streamline-icon-award-trophy-star.6724f94c.svg";
export { ForwardRef as ReactComponent };